import $ from "jquery";
import config from './lib/config';
// import '../css/main.css';

// Components
import './components/ResponsiveMenu';
import './components/Colorbox';
import FadeEffects from './components/FadeEffects';
import LoadMore from './components/LoadMoreInstall';
import WorkPosts from './components/WorkPosts';

export default class App {

    /**
     * init - Initialize the app
     * @return {void} Not meant to return
     */
    static init() {

        document.documentElement.className = "js";
        
        // FadeEffects
        FadeEffects.init();

    	// Journal Page - Load More Posts
    	LoadMore.init();

    	// Apply JS to Work Posts in Work Archive
    	WorkPosts.setHeight();

    }

}

$(document).ready(function(){

    App.init();

});